/**
 * @flow
 * @relayHash 49ed8c353006e95c49a61139d631e283
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type TVShowStateType = "archive" | "available" | "deleted" | "%future added value";
export type TVShowEditInput = {
  id: string,
  title: string,
  isProject?: ?boolean,
  hideDescription?: ?boolean,
  preview?: ?string,
  previewPicture?: ?string,
  shortDescription: string,
  description: string,
  schedule: string,
  category: string,
  persons?: ?$ReadOnlyArray<?string>,
  hidden?: ?boolean,
  state: TVShowStateType,
  order: number,
  clientMutationId?: ?string,
};
export type TVShowEditMutationVariables = {|
  input: TVShowEditInput
|};
export type TVShowEditMutationResponse = {|
  +TVShowEdit: ?{|
    +tvshow: ?{|
      +id: string
    |}
  |}
|};
export type TVShowEditMutation = {|
  variables: TVShowEditMutationVariables,
  response: TVShowEditMutationResponse,
|};
*/


/*
mutation TVShowEditMutation(
  $input: TVShowEditInput!
) {
  TVShowEdit(input: $input) {
    tvshow {
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "TVShowEditInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "TVShowEdit",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "TVShowEditInput!"
      }
    ],
    "concreteType": "TVShowEditPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "tvshow",
        "storageKey": null,
        "args": null,
        "concreteType": "TVShow",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "TVShowEditMutation",
  "id": null,
  "text": "mutation TVShowEditMutation(\n  $input: TVShowEditInput!\n) {\n  TVShowEdit(input: $input) {\n    tvshow {\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "TVShowEditMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "TVShowEditMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '81c5a9cfafdfca553052c2796dc197dc';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/TVShowEditMutation.graphql.js